
import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
  } from 'src/views/termsandconditions'
  import pathMap from 'src/paths/pathMap'
  
  class TermsAndConditionsRoute {
    getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.TERMS_AND_CONDITIONS_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.TERMS_AND_CONDITIONS_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.TERMS_AND_CONDITIONS_EDIT_VIEW,
        component: EditPage
      },      
      {
        exact: true,
        path: pathMap.TERMS_AND_CONDITIONS_DETAILS_VIEW,
        component: ViewPage
      }
    ]
    }
  }
  
  export default TermsAndConditionsRoute
  